module.exports = __webpack_public_path__ + "img/txt.0960409b.svg";